module.exports = __webpack_public_path__ + "static/media/searchSections.36f6be77.jpg";